import type dayjs from 'dayjs';

import { type IFundPortrait, type IShareClassPortrait } from '../components/IFundPortrait';
import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type IFundTabs } from '../models/IFundTabs';
import { type PlotlyResponse } from '../models/PlotlyModel';
import { type TPandasTable } from '../models/TPandasTable';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvMultifundFactsheetService extends CoreJsonAPIService {
  static async getRelevantTabs(simpleFundKey: string) {
    return await super.get<IFundTabs>(EDjangoAppsEndpoints.funds, `${simpleFundKey}/tabs`);
  }

  static async getShareClassPortraits(simpleFundKey: string) {
    return await super.get<IShareClassPortrait[]>(
      EDjangoAppsEndpoints.funds,
      `${simpleFundKey}/share-classes/portrait`
    );
  }

  static async getFundPortrait(simpleFundKey: string) {
    return await super.get<IFundPortrait>(
      EDjangoAppsEndpoints.funds,
      `${simpleFundKey}/portrait`
    );
  }

  static async getOverviewTable(simpleFundKey: string) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.MULTIFUND_FACTSHEET, `${simpleFundKey}/overview/table`);
  }

  static async getOverviewChart(simpleFundKey: string) {
    return await super.get<PlotlyResponse>(EDjangoAppsEndpoints.MULTIFUND_FACTSHEET, `${simpleFundKey}/overview/chart`);
  }

  static async getPerformanceTable(simpleFundKey: string, startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) {
    return await super.get<TPandasTable>(
      EDjangoAppsEndpoints.MULTIFUND_FACTSHEET,
      `${simpleFundKey}/performance/table`,
      {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
      }
    );
  }

  static async getPerformanceChart(simpleFundKey: string, startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) {
    return await super.get<TPandasTable>(
      EDjangoAppsEndpoints.MULTIFUND_FACTSHEET,
      `${simpleFundKey}/performance/chart`,
      {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
      }
    );
  }

  static async countUsage(simpleFundKey: string) {
    return await super.get(
      EDjangoAppsEndpoints.MULTIFUND_FACTSHEET,
      `${simpleFundKey}/counter`
    );
  }

  static async getTosAgreement(targetApplication: string, authenticated: boolean = true) {
    return await super.get<boolean>(EDjangoAppsEndpoints.MULTIFUND_FACTSHEET, this.getTosEndpoint(authenticated), {
      targetApplication
    });
  }

  static async acceptTosAgreement(targetApplication: string, authenticated: boolean = true) {
    return await super.post<boolean>(
      EDjangoAppsEndpoints.MULTIFUND_FACTSHEET,
      this.getTosEndpoint(authenticated),
      undefined,
      {
        params: {
          targetApplication
        }
      }
    );
  }

  private static getTosEndpoint(authenticated: boolean) {
    return `${authenticated ? 'auth' : 'public'}/tos-agreement`;
  }
}
